import { createAction } from '@reduxjs/toolkit';
import type {
  ExportReportLocationParams, ExportReportPolygonParams,
} from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

export const exportReportEnable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_ENABLE',
  (params: ExportReportLocationParams | ExportReportPolygonParams) => ({
    payload: { params },
  })
);

export const exportReportDisable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_DISABLE',
);
